import { render, staticRenderFns } from "./Link.vue?vue&type=template&id=3e12aed3&scoped=true"
import script from "./Link.vue?vue&type=script&lang=ts"
export * from "./Link.vue?vue&type=script&lang=ts"
import style0 from "./Link.vue?vue&type=style&index=0&id=3e12aed3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e12aed3",
  null
  
)

export default component.exports